import { Link } from 'react-router-dom';

const PHONE = '0536 277 17 09';
const PHONE_HREF = 'tel:+905362771709';
const WA_HREF = 'https://wa.me/905362771709';
const EMAIL = 'atatente@hotmail.com';
const ADDRESS = 'Yeşillik Caddesi 5757 Sok. No 22/C Karabağlar / İzmir';

const services = [
  { label: 'Kasetli Tente', href: '/hizmetler/kasetli-tente' },
  { label: 'Körüklü Tente', href: '/hizmetler/koruklu-tente' },
  { label: 'Mafsallı Tente', href: '/hizmetler/mafsalli-tente' },
  { label: 'T Model Tente', href: '/hizmetler/t-model-tente' },
  { label: 'Win Tente', href: '/hizmetler/win-tente' },
  { label: 'Bioklimatik Pergola', href: '/hizmetler/bioklimatik-pergola' },
  { label: 'Otomatik Pergola', href: '/hizmetler/otomatik-pergola' },
  { label: 'Rollingroof Pergola', href: '/hizmetler/rollingroof-pergola' },
  { label: 'Şeffaf Branda', href: '/hizmetler/seffaf-branda' },
  { label: 'Şeffaf Stor Branda', href: '/hizmetler/seffaf-stor-branda' },
  { label: 'Zip Perde', href: '/hizmetler/zip-perde' },
];

const pages = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'SSS', href: '/sss' },
  { label: 'İletişim', href: '/iletisim' },
];

export default function Footer() {
  return (
    <footer className="bg-[#FAF7F2] border-t-4 border-[#D4A853]">
      {/* Top CTA Strip */}
      <div className="bg-[#111827] py-10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-[#D4A853] text-xs font-bold tracking-widest uppercase mb-1">Ücretsiz Keşif</p>
            <h3 className="text-white text-2xl font-black">Projeniz için hemen teklif alın.</h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={PHONE_HREF}
              className="flex items-center gap-2 bg-[#D4A853] text-[#111827] font-bold text-xs tracking-widest uppercase px-6 py-3.5 whitespace-nowrap cursor-pointer hover:bg-[#c49840] transition-colors"
            >
              <i className="ri-phone-line"></i>
              Hemen Ara
            </a>
            <a
              href={WA_HREF}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 border border-white/30 text-white font-bold text-xs tracking-widest uppercase px-6 py-3.5 whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp&apos;tan Yaz
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="mb-5">
            <Link to="/">
              <img src="/logo-dark.webp" alt="Alaçatı Tenteci" width={155} height={58} className="h-10 w-auto" />
            </Link>
          </div>
          <p className="text-[#666] text-sm leading-relaxed">
            Alaçatı ve İzmir&apos;de tente, pergola ve branda sistemlerinde güvenilir çözüm ortağınız. 15+ yıllık deneyim, ücretsiz keşif.
          </p>
          <div className="mt-5 pt-5 border-t border-[#E8E0D0]">
            <p className="text-[#999] text-xs leading-relaxed">
              Hizmet Bölgeleri:<br />
              Alaçatı · Çeşme · Ilıca · Ovacık · Dalyan · Reisdere
            </p>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-xs font-black tracking-widest uppercase text-[#111827] mb-5 pb-3 border-b border-[#E8E0D0]">
            <Link to="/hizmetler">Hizmetlerimiz</Link>
          </h4>
          <ul className="space-y-2.5">
            {services.map((s) => (
              <li key={s.href}>
                <Link
                  to={s.href}
                  className="text-sm text-[#666] hover:text-[#D4A853] transition-colors cursor-pointer flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-[#D4A853] rounded-full flex-shrink-0"></span>
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Pages */}
        <div>
          <h4 className="text-xs font-black tracking-widest uppercase text-[#111827] mb-5 pb-3 border-b border-[#E8E0D0]">
            Sayfalar
          </h4>
          <ul className="space-y-2.5">
            {pages.map((p) => (
              <li key={p.href}>
                <Link
                  to={p.href}
                  className="text-sm text-[#666] hover:text-[#D4A853] transition-colors cursor-pointer flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-[#D4A853] rounded-full flex-shrink-0"></span>
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-xs font-black tracking-widest uppercase text-[#111827] mb-5 pb-3 border-b border-[#E8E0D0]">
            İletişim
          </h4>
          <div className="space-y-4">
            <a
              href={PHONE_HREF}
              className="flex items-start gap-3 group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#111827] flex-shrink-0">
                <i className="ri-phone-line text-[#D4A853] text-sm"></i>
              </div>
              <div>
                <p className="text-xs text-[#999] uppercase tracking-wider">Telefon</p>
                <p className="text-sm font-bold text-[#111827] group-hover:text-[#D4A853] transition-colors">{PHONE}</p>
              </div>
            </a>
            <a
              href={WA_HREF}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-start gap-3 group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#111827] flex-shrink-0">
                <i className="ri-whatsapp-line text-green-400 text-sm"></i>
              </div>
              <div>
                <p className="text-xs text-[#999] uppercase tracking-wider">WhatsApp</p>
                <p className="text-sm font-bold text-[#111827] group-hover:text-[#D4A853] transition-colors">Hızlı Teklif Al</p>
              </div>
            </a>
            <a
              href={`mailto:${EMAIL}`}
              className="flex items-start gap-3 group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#111827] flex-shrink-0">
                <i className="ri-mail-line text-[#D4A853] text-sm"></i>
              </div>
              <div>
                <p className="text-xs text-[#999] uppercase tracking-wider">E-posta</p>
                <p className="text-sm font-bold text-[#111827] group-hover:text-[#D4A853] transition-colors break-all">{EMAIL}</p>
              </div>
            </a>
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 flex items-center justify-center bg-[#111827] flex-shrink-0">
                <i className="ri-map-pin-line text-[#D4A853] text-sm"></i>
              </div>
              <div>
                <p className="text-xs text-[#999] uppercase tracking-wider">Adres</p>
                <p className="text-sm text-[#555] leading-relaxed">{ADDRESS}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#E8E0D0]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-[#999] text-xs">
            © {new Date().getFullYear()} Alaçatı Tenteci. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/kvkk" className="text-[#bbb] text-xs hover:text-[#D4A853] transition-colors">KVKK</Link>
            <span className="text-[#ddd]">·</span>
            <Link to="/cerez-politikasi" className="text-[#bbb] text-xs hover:text-[#D4A853] transition-colors">Çerez Politikası</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
